export class CM_Menu_Helper {

    selected_element_selector       = null;
    parent_element_selector         = null;

    constructor(selected_element_selector, parent_element_selector){
        this.selected_element_selector      = selected_element_selector;
        this.parent_element_selector        = parent_element_selector;
    }

}